import React from "react";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { locations, brand } from "../data/siteData";
import useScrollReveal, { revealUp } from "../hooks/useScrollReveal";
import "./LocationAtlas.css";

export default function LocationAtlas() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".atlas__panel"), {
      ...revealUp(null, el.querySelector(".atlas__split")),
      stagger: 0.12,
    });
  }, []);

  return (
    <section id="locations" className="atlas" ref={sectionRef}>
      <div className="atlas__header container">
        <span className="eyebrow">Two Locations, One Grid</span>
        <h2 className="atlas__title">
          THE SOLAR
          <br />
          <span className="accent-text">ATLAS</span>
        </h2>
        <p className="atlas__intro">
          {brand.name} operates from two Kerala locations, each running
          the same design and installation standard.
        </p>
      </div>

      <div className="atlas__split">
        {locations.map((loc) => (
          <Link to={`/locations/${loc.slug}`} key={loc.id} className="atlas__panel">
            <div
              className="atlas__panel-image"
              style={loc.image ? { backgroundImage: `url(${loc.image})` } : undefined}
            />
            <div className="atlas__panel-body">
              <span className="atlas__panel-code">{loc.label || `Location ${loc.code}`}</span>
              <h3 className="atlas__panel-name">{loc.city}</h3>
              <p className="atlas__panel-desc">{loc.description}</p>
              <div className="atlas__panel-meta">
                <span>{loc.address}</span>
                <span>{loc.phone}</span>
              </div>
              <span className="atlas__panel-link">
                Visit location <HiArrowRight />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
